export const ACTION_TITLE_LENGTH_MAX = 100;

export const ISSUE_TITLE_LENGTH_MAX = 255;

export const ISSUE_DESCRIPTION_LENGTH_MAX = 1000;

export const ISSUE_IMPACT_LENGTH_MAX = 10000;

export const ACTION_DESCRIPTION_LENGTH_MAX = 1000;

export const ISSUE_COMMENT_LENGTH_MAX = 1000;

export const DECLINE_REASON_LENGTH_MAX = 1000;

export const DECLINE_REASON_LENGTH_MIN = 1;

export const DISCARD_MESSAGE_LENGTH_MAX = 1000;

export const SLA_DESCRIPTION_LENGTH_MAX = 100;
export const MAX_DUE_DATE_DAYS = 9999;
export const MAX_DATE_PICKER_DATE = new Date('2099-12-31T00:00:00.000');

export const SUBTYPE_NAME_LENGTH_MAX = 100;
export const ROOT_CAUSE_LENGTH_MAX = 10000;
export const RECOMMENDATIONS_LENGTH_MAX = 10000;
export const MANAGEMENT_RESPONSE_LENGTH_MAX = 10000;
export const REMEDIATION_LENGTH_MAX = 10000;

export const ISSUE_SUBTYPE_NONE_VALUE = '_none_';

export const RICH_TEXT_ALLOWED_TAGS = [
  'strong',
  'span',
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'i',
  'b',
  'u',
  'em',
  'br',
  'ul',
  'ol',
  'li',
  'pre',
  'a',
] as const;

export const RICH_TEXT_ALLOWED_ATTRIBUTES: Record<string, string[]> = {
  '*': ['class', 'dir', 'lang', 'style'],
  a: ['href', 'id', 'name', 'target', 'rel', 'title'],
};

export const RICH_TEXT_ALLOWED_SCHEMES = ['http', 'https'] as const;
